"use client";

import { useState } from "react";
import Link from "next/link";
import StripeButton from "@/components/StripeButton"; // Bouton pour paiement CB
import { FaPaypal, FaUserCheck } from "react-icons/fa6";

const AdhererPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    type: "standard",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >,
  ) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <main className="container mx-auto px-4 py-12">
      <h1 className="text-center text-4xl font-bold text-gray-900 dark:text-white">
        Adhérer à l'Association
      </h1>
      <p className="mt-2 text-center text-gray-600 dark:text-gray-300">
        Rejoignez-nous et participez à nos actions en devenant membre.
      </p>

      {/* 🔹 Confirmation après soumission */}
      {submitted ? (
        <div className="mt-6 rounded-lg bg-green-100 p-6 text-center dark:bg-green-900">
          <FaUserCheck className="mx-auto mb-2 text-3xl text-green-600 dark:text-green-400" />
          <h2 className="text-lg font-semibold text-green-600 dark:text-green-400">
            Merci pour votre adhésion !
          </h2>
          <p className="mt-2 text-gray-700 dark:text-gray-300">
            Veuillez procéder au paiement de votre cotisation pour finaliser
            votre inscription.
          </p>
        </div>
      ) : (
        <div className="mx-auto mt-8 max-w-2xl rounded-lg bg-white p-6 shadow dark:bg-gray-800">
          {/* 🔹 Formulaire d'adhésion */}
          <form onSubmit={handleSubmit} className="space-y-4">
            <input
              type="text"
              name="name"
              placeholder="Nom et prénom"
              className="w-full rounded-lg border p-2"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Email"
              className="w-full rounded-lg border p-2"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <input
              type="tel"
              name="phone"
              placeholder="Téléphone"
              className="w-full rounded-lg border p-2"
              value={formData.phone}
              onChange={handleChange}
            />
            <input
              type="text"
              name="address"
              placeholder="Adresse"
              className="w-full rounded-lg border p-2"
              value={formData.address}
              onChange={handleChange}
            />

            {/* 🔹 Choix du type d'adhésion */}
            <select
              name="type"
              className="w-full rounded-lg border p-2"
              value={formData.type}
              onChange={handleChange}
              required
            >
              <option value="standard">Membre Standard - 20€</option>
              <option value="bienfaiteur">Membre Bienfaiteur - 50€</option>
              <option value="soutien">Membre Soutien - 100€</option>
            </select>

            {/* 🔹 Champ Message */}
            <textarea
              name="message"
              placeholder="Laissez un message (optionnel)"
              className="w-full rounded-lg border p-2"
              value={formData.message}
              onChange={handleChange}
            />

            <button
              type="submit"
              className="w-full rounded-lg bg-blue-600 px-4 py-2 text-white hover:bg-blue-800"
            >
              Valider mon adhésion
            </button>
          </form>
        </div>
      )}

      {/* 🔹 Paiement de la cotisation */}
      {submitted && (
        <section className="mt-12 text-center">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
            Régler votre cotisation
          </h2>
          <p className="mt-2 text-gray-600 dark:text-gray-300">
            Sélectionnez un mode de paiement.
          </p>

          {/* 🔹 Paiement CB avec Stripe */}
          <StripeButton />

          {/* 🔹 Paiement avec PayPal */}
          <div className="mt-6">
            <Link
              href="https://www.paypal.com/donate?hosted_button_id=VOTRE_ID_PAYPAL"
              target="_blank"
            >
              <button className="mx-auto flex items-center justify-center rounded-lg bg-blue-600 px-6 py-3 text-white hover:bg-blue-800">
                <FaPaypal className="mr-2 text-2xl" /> Payer avec PayPal
              </button>
            </Link>
          </div>
        </section>
      )}
    </main>
  );
};

export default AdhererPage;
